// extracted by mini-css-extract-plugin
export default {"tagInputWrapper":"TagInput_tagInputWrapper__5CNyl","tagInput":"TagInput_tagInput__n11+x","tagsContainer":"TagInput_tagsContainer__CpUpW","tagChip":"TagInput_tagChip__-rxur"};